import React from 'react';
import { useAuth } from '../context/AuthContext';

interface ProtectedClickProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * 로그인하지 않은 상태에서 클릭 시 로그인 모달을 띄우는 래퍼 컴포넌트
 */
export const ProtectedClick: React.FC<ProtectedClickProps> = ({ children, className = '' }) => {
  const { isLoggedIn, setShowLoginModal } = useAuth();

  const handleClick = (e: React.MouseEvent) => {
    if (!isLoggedIn) {
      e.preventDefault();
      e.stopPropagation();
      setShowLoginModal(true);
    }
  };

  return (
    <div
      className={className}
      onClick={handleClick}
      style={!isLoggedIn ? { cursor: 'pointer' } : undefined}
    >
      {children}
    </div>
  );
};

interface ProtectedContentProps {
  children: React.ReactNode;
}

/**
 * 로그인하지 않은 상태에서 모든 클릭을 차단하고 로그인 모달을 띄우는 오버레이 래퍼
 */
export const ProtectedContent: React.FC<ProtectedContentProps> = ({ children }) => {
  const { isLoggedIn, setShowLoginModal } = useAuth();

  const handleContentClick = (e: React.MouseEvent) => {
    if (!isLoggedIn) {
      // 모든 클릭 이벤트 차단
      e.preventDefault();
      e.stopPropagation();
      setShowLoginModal(true);
      return false;
    }
  };

  return (
    <div
      onClick={handleContentClick}
      className="bg-slate-100"
      style={{
        position: 'relative',
        pointerEvents: !isLoggedIn ? 'auto' : 'auto',
      }}
    >
      {/* 로그인하지 않은 상태에서 투명한 오버레이 */}
      {!isLoggedIn && (
        <div
          className="fixed inset-0 z-20 bg-transparent"
          style={{ top: '5rem' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowLoginModal(true);
          }}
        />
      )}
      {children}
    </div>
  );
};
